
class AlertMessage{
    constructor(){
        this.main = document.getElementById('alert_message');

        this._textHolder = this.main.querySelector('.alert-message__text');

    }

    show(text, success = false){
        this._textHolder.innerHTML = text;

        if(success){
            this.main.classList.add('alert-message--success');
            this.main.classList.remove('alert-message--error');
        }else{
            this.main.classList.remove('alert-message--success');
            this.main.classList.add('alert-message--error');
        }

        this.main.classList.add('alert-message--show');

        setTimeout(this.hide.bind(this), 3000);
    }

    hide(){
        this.main.classList.remove('alert-message--show');
    }

}

export default AlertMessage;